import React from "react";
import { styled } from "styled-components";
import { Paragraph, TextLink } from "../../Text";
import { rem } from "../../../utils";
const StyledFooterPrivacyNote = styled.div `
  margin: ${rem(40)} 0 ${rem(10)};
  > p {
    margin: 0;
  }
`;
export const FooterPrivacyNote = ({ locale }) => (React.createElement(StyledFooterPrivacyNote, null,
    locale === "nb" && (React.createElement(Paragraph, null,
        "Vi respekterer og beskytter personvernet og personopplysningene dine.\u00A0Les om",
        " ",
        React.createElement(TextLink, { href: "https://fjordline.com/nb/p/informasjonskapsler" }, "bruk av informasjonskapsler (cookies)"),
        ", og om hvordan Fjord Line samler inn og bruker",
        " ",
        React.createElement(TextLink, { href: "https://fjordline.com/nb/p/personvern" }, "personopplysninger"),
        ".")),
    locale === "en" && (React.createElement(Paragraph, null,
        "We respect and protect your privacy and personal information. Read about the",
        " ",
        React.createElement(TextLink, { href: "https://fjordline.com/en/p/cookiedeclaration" }, "use of cookies"),
        " ",
        "and how Fjord Line collects and uses",
        " ",
        React.createElement(TextLink, { href: "https://fjordline.com/en/p/privacy" }, "personal information"),
        ".")),
    locale === "nl" && (React.createElement(Paragraph, null,
        "We respecteren en beschermen uw privacy en persoonlijke informatie. Lees meer over het",
        " ",
        React.createElement(TextLink, { href: "https://fjordline.com/nl/p/cookieverklaring" }, "gebruik van cookies"),
        " ",
        "en hoe Fjord Line",
        " ",
        React.createElement(TextLink, { href: "https://fjordline.com/nl/p/privacy" }, "persoonlijke informatie"),
        " ",
        "verzamelt en gebruikt.")),
    locale === "de" && (React.createElement(Paragraph, null,
        "Wir respektieren und sch\u00FCtzen Ihre Privatsph\u00E4re und Ihre pers\u00F6nlichen Daten. Informieren Sie sich \u00FCber die",
        " ",
        React.createElement(TextLink, { href: "https://fjordline.com/de/p/cookie-erklaerung" }, "Nutzung von Cookies"),
        " ",
        "und die Art und Weise, wie Fjord Line",
        " ",
        React.createElement(TextLink, { href: "https://fjordline.com/de/p/datenschutz" }, "pers\u00F6nliche Daten"),
        " ",
        "sammelt und verwendet.")),
    locale === "da" && (React.createElement(Paragraph, null,
        "Vi respekterer og beskytter dit privatliv og dine personoplysninger. L\u00E6s om",
        " ",
        React.createElement(TextLink, { href: "https://fjordline.com/da/p/cookiedeklaration" }, "brug af cookies"),
        ", og om hvordan Fjord Line indsamler og bruger",
        " ",
        React.createElement(TextLink, { href: "https://fjordline.com/da/p/privatlivspolitik" }, "personoplysninger"),
        "."))));
export default FooterPrivacyNote;
//# sourceMappingURL=index.js.map